<template>
    <div class="row ganzeZeileMitAbstand">
        <div class="col-12 search-tools-center">
            <h2 v-if="searchCount > 0">{{searchCount}} {{dictionary['SUCHE_Ergebnisse_gefunden']}}{{searchTerm}}{{dictionary['SUCHE_Ergebnisse_gefunden_ende']}}</h2>
            <h2 v-if="searchCount === 0">{{dictionary['SUCHE_Keine_Ergebnisse_gefunden']}}</h2>
            <div class="contentSearchCategories">
                <!-- {{ searchCategories }} -->
                <template v-for="category in searchCategories">
                    <button class="al-btn-search-category"  v-if="category.results && category.results.length !== 0" @click="showResults(category)" :class="[category.isActive ? 'current' : '']"> {{category.name}} <span>{{category.results.length}}</span></button>
                </template>        
            </div>
        </div>
    </div>
    <div class="row ganzeZeileMitAbstand">
            <div class="col col-12">
                <div class="contentSearchResults">
                    <template v-for="category in searchCategories">    
                       <!-- Arzneimittel -->
                        <div class="row" :class="'contentSearchResult'+category.alias" v-if="category.isActive && category.alias ==='Arzneimittel (System)'">
                            <div class="col-12 col-md-4" v-for="result in category.results">
                                <div class="product-item" :class="result.otcKategorieId">
                                    <SearchResultItem
                                        :product="result"
                                        @readmore="onReadMore"
                                        @order="onOrder"
                                        @pflichttext="onPflichttext"
                                    />
                                </div>
                            </div>
                            <more-button :total="category.totalResults ?? 0" :elements="category.results.length" :element="category" :emit="'loadMoreSearch'"></more-button>
                        </div>
                        
                        <!-- Gesundheitsthemen -->
                        <div class="row teaser-all teaser-cols" :class="'contentSearchResult'+category.alias" v-else-if="category.alias === 'Gesundheitsthemen' && category.isActive">
                            <div class="col-12 col-md-4 custom-mb3" v-for="result in category.results">
                                <div class="al-teaser" :class="result.otcKategorieId">
                                    <div v-if="result.bild" class="ff-bild">
                                        <figure>
                                            <a @click.prevent="openResultUrl(result.url)" title="{{dictionary['SUCHE_Gesundheitsthemen_LinkText']}}">
                                                <!-- <img class="img-fluid lazy" src="~/images/placeholder.svg" :data-src="result.bild" /> -->
                                                <img class="img-fluid lazy" :data-src="result.bild" />
                                            </a>
                                        </figure>
                                    </div>

                                    <p class="teaser-category">{{result.topline}}</p>

                                    <div class="control-wrapper ff-rte">
                                        <h3>{{result.titel}}</h3>
                                        <p>{{result.vorschautext}}</p>
                                    </div>
                                    <p class="teaser-button">
                                        <a @click.prevent="openResultUrl({key:result.id, url:result.url})">{{dictionary["SUCHE_Gesundheitsthemen_LinkText"]}}</a>
                                    </p>

                                </div>
                            </div>    
                            <more-button :total="category.totalResults ?? 0" :elements="category.results.length" :element="category" :emit="'loadMoreSearch'"></more-button>
                        </div>
                         <!-- Downloads -->
                        <div class="row mx-0" :class="'contentSearchResult'+category.alias" v-else-if="category.alias === 'Downloads (System)' && category.isActive">
                            <div class="col-12" v-for="result in category.results">
                                <div class="row element-download">
                                    <div class="col-6 col-md-8 download-content">
                                        <h3>{{result.vorschauTitel}}</h3>
                                        <p>{{result.vorschauText}}</p>
                                    </div>
                                    <div class="col-6 col-md-4 p-0 download-info">
                                        <div class="download-block">
                                            <a class="btn btn-download" :href="result.url" :download="result.name">{{dictionary["SUCHE_Downloads_LinkText"]}}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <more-button :total="category.totalResults ?? 0" :elements="category.results.length" :element="category" :emit="'loadMoreSearch'"></more-button>
                        </div>
                        <!-- Blog -->
                        <div class="row teaser-all":class="'contentSearchResult'+category.alias" v-else-if="category.alias === 'Blog (System)' && category.isActive">
                            <div class="col-12">
                                <div style="display: flex; margin-left: -25px; flex-wrap: wrap;">
                                    <div v-for="result in category.results"  style="box-sizing: border-box; background-clip: padding-box; width: 33.3333%; border-width: 0px 0px 0px 25px; border-style: solid; border-color: transparent; border-image: initial; margin-bottom: 2rem;">
                                        <news-detail 
                                            :detail="result"
                                            :read_more_text="dictionary['SUCHE_Gesundheitsthemen_LinkText']"
                                            :emitreadmore="emitNews"
                                        ></news-detail>
                                    </div>
                               </div>
                                <more-button :total="category.totalResults ?? 0" :elements="category.results.length" :element="category" :emit="'loadMoreSearch'"></more-button>
                            </div>
                        </div>
                        <!-- Default View -->
                        <div :class="'contentSearchResult'+category.alias" v-else-if="category.isActive">
                            <div class="row teaser-all" v-if="category.isActive">
                                <div class="col-12 custom-mb3" v-for="result in category.results">
                                    <div class="al-teaser page-element">
                                        <p class="page-path">
                                            <span v-if="!result.breadcrumbs.length">Home</span>
                                            <span v-for="(crumb, index) in result.breadcrumbs" :class="[index != result.breadcrumbs.length - 1 ? 'seperator' : '']">{{crumb}}</span>
                                        </p>
                                        <h3>{{result.titel}}</h3>
                                        <p>{{result.vorschautext}}</p>
                                        <div class="page-block">
                                            <a class="btn btn-page" @click.prevent="openResultUrl({key:result.id, url:result.url})">{{dictionary["SUCHE_Seiten_LinkText"]}}</a>
                                        </div>
                                    </div>
                                </div>
                            <more-button :total="category.totalResults ?? 0" :elements="category.results.length" :element="category" :emit="'loadMoreSearch'"></more-button>
                            </div>
                        </div> 
                       
                    </template>
                </div>
            </div>
        </div>
    

</template>

<script setup lang="ts">
    import { onBeforeMount } from 'vue';
    import { emitterInstance } from '@/classes/emitter';
    import { useContentSearch, type SearchCategory } from '../composables/useContentSearch';
    import SearchResultItem from '@/vue_components/product-overview/search-result-item/search-result-item.vue';
    import moreButton from './more-button.vue';
import NewsDetail from '@/vue_components/news-overview/news-detail.vue';

    const dictionary = {
        'SUCHE_Ergebnisse_gefunden': 'gefundene Ergebnisse für "',
        'SUCHE_Ergebnisse_gefunden_ende': '"',
        'SUCHE_Keine_Ergebnisse_gefunden': 'Kein Ergebnis gefunden',
        'SUCHE_Gesundheitsthemen_LinkText': 'Weiterlesen',
        'SUCHE_Downloads_LinkText': 'Pdf herunterladen',
        'SUCHE_Seiten_LinkText': 'Seite aufrufen',
    }
    const emitNews="readMoreSearchNews"
    const { searchTerm,
            searchCategories,
            searchCount,
            search,
            initializeSearchCategories,
            onReadMore,
            onOrder,
            onPflichttext,
            moreResults,
            setSearchHistory
            }=useContentSearch()

            
    onBeforeMount(async ()=>{
        initializeSearchCategories();

        emitterInstance.on("contentSearch", async(term) =>{
                await search(term as string);
                showResults();
        })    
        emitterInstance.on("loadMoreSearch", async(category) =>{
            moreResults(searchTerm.value, category as SearchCategory, searchCategories.value);        
        })    
        emitterInstance.on(emitNews, async(resultElement) =>{
           openResultUrl(resultElement as {key:string, url:string});      
        })
    })
    
    // methods
    
    function showResults(category:any=undefined){
        let firstCat = -1;
        for(let i =0; i< searchCategories.value.length; i++){
            if(firstCat<0 && searchCategories.value[i].results && searchCategories.value[i].results.length>0){
                firstCat = i;
            };
            searchCategories.value[i].isActive = false;
        }
        if(category != undefined){
            category.isActive= true;
        }else{
            searchCategories.value[firstCat].isActive = true;
        }
    }
    function openResultUrl(result: {key:string, url:string}){ 
        setSearchHistory(result.key);
        window.location.href = result.url;
    }
</script>